import { atom } from 'jotai';
import { RESET } from 'jotai/utils';
import {
  answerErrorAtom,
  answerMapAtom,
  savingAnswerIdsAtom,
  unsavedAnswersAtom
} from '@/_atoms/answer';
import {
  demographicErrorAtom,
  demographicMapAtom,
  savingDemographicIdsAtom,
  unsavedDemographicsAtom
} from '@/_atoms/demographic';
import {
  customIdFieldAtom,
  isSavingUserAtom,
  loginCodeAtom,
  loginErrorAtom,
  loginRequestAtom,
  loginStatusAtom,
  userAtom,
  userErrorMessageAtom,
} from '@/_atoms/auth';
import {
  emailVerificationCodeAtom,
  emailVerificationCodeValueAtom,
  emailVerificationErrorMessageAtom,
  isSendingEmailVerificationAtom,
  isVerifyingEmailCodeAtom,
} from '@/_atoms/emailVerification';
import {
  loginCodeEmailRequestErrorMessageAtom,
  isSendingLoginCodeAtom,
} from '@/_atoms/loginCodeEmailRequest';
import { languageIdAtom } from '@/_atoms/language';
import {
  elementIndexAtom,
  hasInternetConnectionAtom,
  timeRemainingAtom
} from '@/_atoms/navigation';
import {
  celebrationAtom,
  progressionErrorAtom,
  progressionsAtom,
  savingProgressionIdsAtom,
  unsavedProgressionIdsAtom
} from '@/_atoms/progress';
import {
  hasUnsavedRespondentChangesAtom,
  isSavingRespondentAtom,
  respondentAtom,
  respondentErrorAtom
} from '@/_atoms/respondent';
import {
  pollingScoringRunIdsAtom,
  scoringRunErrorAtom
} from '@/_atoms/scoringRun';
import { surveyIdAtom } from '@/_atoms/survey';

export const resetAppAtom = atom(null, (_get, set) => {
  // clear ephemeral storage
  sessionStorage.removeItem('session');

  // Answers
  set(answerMapAtom, RESET);
  set(answerErrorAtom, RESET);
  set(savingAnswerIdsAtom, RESET);
  set(unsavedAnswersAtom, RESET);

  // Demographics
  set(demographicMapAtom, RESET);
  set(demographicErrorAtom, RESET);
  set(savingDemographicIdsAtom, RESET);
  set(unsavedDemographicsAtom, RESET);

  // Auth
  set(customIdFieldAtom, RESET);
  set(isSavingUserAtom, RESET);
  set(loginCodeAtom, RESET);
  set(loginErrorAtom, RESET);
  set(loginRequestAtom, RESET);
  set(loginStatusAtom, RESET);
  set(userAtom, RESET);
  set(userErrorMessageAtom, RESET);

  // Email verification
  set(emailVerificationCodeAtom, RESET);
  set(emailVerificationCodeValueAtom, RESET);
  set(emailVerificationErrorMessageAtom, RESET);
  set(isSendingEmailVerificationAtom, RESET);
  set(isVerifyingEmailCodeAtom, RESET);

  // Login code email requests
  set(loginCodeEmailRequestErrorMessageAtom, RESET);
  set(isSendingLoginCodeAtom, RESET);

  // Language
  set(languageIdAtom, RESET);

  // Navigation
  set(elementIndexAtom, RESET);
  set(hasInternetConnectionAtom, RESET);
  set(timeRemainingAtom, RESET);

  // Progress
  set(celebrationAtom, RESET);
  set(progressionsAtom, RESET);
  set(progressionErrorAtom, RESET);
  set(savingProgressionIdsAtom, RESET);
  set(unsavedProgressionIdsAtom, RESET);

  // Respondent
  set(isSavingRespondentAtom, RESET);
  set(hasUnsavedRespondentChangesAtom, RESET);
  set(respondentErrorAtom, RESET);
  set(respondentAtom, RESET);

  // Scoring run
  set(pollingScoringRunIdsAtom, RESET);
  set(scoringRunErrorAtom, RESET);

  // Survey
  set(surveyIdAtom, RESET);
});